import React, { useEffect } from "react";
import { motion } from "framer-motion";

export const Seo = ({ title, description }) => {
  useEffect(() => {
    document.title = title;
    const m = document.querySelector('meta[name="description"]');
    if (m && description) m.setAttribute("content", description);
  }, [title, description]);
  return null;
};

export const fadeUp = {
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
};

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div {...fadeUp} transition={{ ...fadeUp.transition, delay }} className={className}>
    {children}
  </motion.div>
);

export const Section = ({ id, children, className = "" }) => (
  <section id={id} className={`py-24 md:py-32 ${className}`}>
    <div className="max-w-7xl mx-auto px-6 md:px-12">{children}</div>
  </section>
);

export const SectionHead = ({ label, title, intro }) => (
  <FadeUp className="max-w-3xl mb-14">
    <div className="dz-label mb-4">{label}</div>
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight text-white">{title}</h2>
    {intro && <p className="mt-5 text-base md:text-lg text-zinc-400 leading-relaxed">{intro}</p>}
  </FadeUp>
);
